import { render, staticRenderFns } from "./QuestionGroupSelector.vue?vue&type=template&id=44fd0037&scoped=true&"
import script from "./QuestionGroupSelector.vue?vue&type=script&lang=js&"
export * from "./QuestionGroupSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fd0037",
  null
  
)

export default component.exports